export default {
  title: {
    id: 'profile_page_contact_details_tab_additional_contact_block_title',
    defaultMessage: 'Additional contacts',
  },
  description: {
    id: 'profile_page_contact_details_tab_additional_contact_block_description',
    defaultMessage:
      'Add as many team members as you want. Just let us know what kind of automated emails they need to receive.',
  },
  submitButton: {
    id: 'profile_page_contact_details_tab_additional_contact_block_submit_button',
    defaultMessage: 'Add contact',
  },
  deleteButton: {
    id: 'profile_page_contact_details_tab_additional_contact_block_delete_button',
    defaultMessage: 'Delete contact',
  },
  contactTypeslabel: {
    id: 'profile_page_contact_details_tab_additional_contact_block_contact_types_label',
    defaultMessage: 'Type of contact',
  },
  toastErrorContent: {
    id: 'profile_page_delete_contact_toast_error_generic_content',
    defaultMessage: 'We are sorry, something went wrong!',
  },
  toastDeleteSuccessContent: {
    id: 'profile_page_delete_contact_toast_succcess_content',
    defaultMessage: 'Contact deleted ✔️',
  },
  toastAddSuccessContent: {
    id: 'profile_page_add_contact_toast_succcess_content',
    defaultMessage: 'Contact added ✔️',
  },
  emailLabel: {
    id: 'input_email_label',
    defaultMessage: 'Email',
  },
  emailRequired: {
    id: 'input_email_required',
    defaultMessage: 'The email field is required',
  },
  emailInvalid: {
    id: 'input_email_invalid',
    defaultMessage: 'This email seems to be invalid',
  },
  fieldIsRequired: {
    id: 'merchant_register_form_fields_required',
    defaultMessage: 'This field is required',
  },
}
